import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgValentines = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m4.688 10.932 2.21 2.103a.75.75 0 1 1-1.033 1.087l-2.224-2.115-.025-.025c-2.469-2.577-1.854-6.3.133-8.364 1.013-1.052 2.422-1.726 4.023-1.604 1.404.107 2.854.817 4.236 2.235 1.381-1.416 2.83-2.124 4.232-2.228 1.6-.119 3.005.56 4.015 1.613 1.98 2.066 2.597 5.787.145 8.354l-.026.027-7.85 7.443a.75.75 0 0 1-1.032 0l-1.415-1.339a.75.75 0 0 1 1.031-1.09l.9.852 7.32-6.941c1.772-1.87 1.384-4.661-.156-6.268-.753-.785-1.739-1.235-2.821-1.155-1.084.08-2.398.704-3.77 2.332a.75.75 0 0 1-1.147 0c-1.371-1.63-2.688-2.256-3.776-2.34-1.086-.082-2.075.366-2.828 1.15-1.542 1.601-1.932 4.391-.142 6.273m6.049 2.432c.3.286.31.76.024 1.06L9.31 15.945V18.7a.75.75 0 0 1-.208.518l-2.435 2.55a.75.75 0 0 1-1.292-.518v-2.208a.3.3 0 0 0-.013-.089l-.001-.004a.2.2 0 0 0-.046-.005H3.205a.75.75 0 0 1-.542-1.268l2.435-2.55a.75.75 0 0 1 .543-.232h2.597l1.438-1.506a.75.75 0 0 1 1.06-.024m-5.778 4.08 1.002-1.05H7.81V18.4l-.935.98v-.337c0-.412-.133-.82-.428-1.13a1.54 1.54 0 0 0-1.132-.468z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgValentines;
